import { Pipe, PipeTransform, inject } from '@angular/core';
import { RmaUrlsService } from '../rma-urls.service';

@Pipe({
  name: 'staticAssetUrl',
  standalone: true,
})
export class StaticAssetUrlPipe implements PipeTransform {
  private readonly rmaUrls = inject(RmaUrlsService);

  transform(value: string): string {
    return this.rmaUrls.staticAssetUrl(value);
  }
}
